import ProductCardSkeleton from '@/components/common/Skeleton/brand-card';

export default function CardLineSkeleton() {
  return (
    <div className="my-2.5 overflow-hidden">
      <div className="flex justify-between relative px-5">
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-24 rounded-sm skeleton" />
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-20 rounded-700 skeleton" />
      </div>
      <div className="overflow-x-auto pt-0 ml-5 mt-[5px] flex flex-nowrap">
        {new Array(3).fill(0).map((_item, index) => {
          return (
            <ProductCardSkeleton
              className="flex-shrink-0 mr-5"
              key={`skeleton-product-list-item-${index}`}
              // className={classNames('flex-shrink-0 !w-[180px]')}
            />
          );
        })}
      </div>
    </div>
  );
}
